import React from 'react';
import { FaMapMarkerAlt, FaClipboardList } from 'react-icons/fa';
import { useApp } from '../../../context/AppContext';
import { DashboardChartGrid, KpiGrid, PortalHero } from '../../../components_shared/PortalDashboard';

export default function TODashboardPage(){
 const { user } = useApp();
 const cards=[
   {icon:<FaMapMarkerAlt/>, label:'Talukas', value:4, className:'eduss-dashboard-card-blue'},
   {icon:<FaClipboardList/>, label:'Pending Tasks', value:15, className:'eduss-dashboard-card-yellow'}
 ];
 return (
   <div className="eduss-dashboard">
     <PortalHero title={`Welcome, ${user?.username || 'TO'}!`} subtitle="Track taluka operations, assigned tasks, and enrollment movement." />
     <KpiGrid cards={cards.map(c=>({...c,desc:'Current operational count'}))} />
     <DashboardChartGrid charts={[
       {title:'TO Workload',caption:'Current view',type:'bar',data:cards.map(c=>({name:c.label,value:c.value})),color:'#0f6fad'},
       {title:'Task Movement',caption:'Snapshot',type:'line',data:cards.map(c=>({name:c.label,value:c.value})),color:'#10ac84'}
     ]} />
   </div>
 );
}
